import { Box, styled } from '@mui/joy';

interface IProps {
  error?: boolean;
  disabled?: boolean;
  height?: string | number;
  name?: string;
}

const propsToSkip: PropertyKey[] = ['error', 'disabled', 'height'];
const shouldForwardProp = (propName: PropertyKey) => !propsToSkip.includes(propName);

const TOOLBAR_HEIGHT = 56;

export const TextEditorWrapper = styled(Box, { shouldForwardProp })<IProps>(
  ({ theme, error, disabled, height }) => ({
    cursor: disabled ? 'not-allowed' : 'auto',

    ['.quill']: {
      height: height,
      borderTop: 0,
      borderRadius: 3,
      border: `${error ? 2 : 1}px solid ${
        error ? theme.palette.danger.outlinedBorder : theme.palette.neutral.outlinedBorder
      }`,
      backgroundColor: theme.palette.background.surface,
    },

    ['.ql-picker-label']: {
      color: theme.palette.neutral[900],
      cursor: disabled ? 'not-allowed' : 'pointer',
    },

    ['.ql-formats button']: {
      cursor: disabled ? 'not-allowed' : 'pointer',
    },

    ['.ql-stroke']: {
      stroke: theme.palette.neutral[900],
      cursor: disabled ? 'not-allowed' : 'pointer',
    },

    ['.ql-toolbar.ql-snow']: {
      display: 'flex',
      alignItems: 'center',
      height: TOOLBAR_HEIGHT,
      border: 'none',
      borderBottom: `1px solid ${theme.palette.neutral.outlinedBorder}`,
    },

    ['.ql-container.ql-snow']: {
      border: 'none',
      height: `calc(100% - ${TOOLBAR_HEIGHT}px)`,
    },
  })
);
